module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-building-c1c44874854160d5d78f747c1afc1c8a.svg";